const formatUSD = (number: number): string => {
    const usdFormatter: Intl.NumberFormat = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return usdFormatter.format(number);
}

const formatDateLong = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
    return date.toLocaleDateString('en-US', options);
}

const formatDateString = (dateStr: string | Date): string => {
    if (!dateStr) {
        return '';
    }

    let date: Date;

    if (dateStr instanceof Date) {
        date = dateStr;
    } else {
        // Handle different date string formats from the database
        const dateString = dateStr.toString();

        // If it's in ISO format (YYYY-MM-DD) or datetime format
        if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
            // Parse as the local date to avoid UTC interpretation
            const datePart = dateString.split(/[T ]/)[0]; // Get just the date part
            const [year, month, day] = datePart.split('-').map(Number);
            date = new Date(year, month - 1, day); // Create local date (month is 0-indexed)
        } else {
            // For other formats, use normal parsing
            date = new Date(dateString);
        }
    }

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Los_Angeles' // Ensure consistent timezone
    };
    return date.toLocaleDateString('en-US', options);
}

const formatDateTimeForQuery = (date: Date | string): string => {
    const d = date instanceof Date ? date : new Date(date);
    d.setHours(0, 0, 0, 0); // 00:00:00.000 today
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset()); // Adjust for DB (UTC) discrepancy
    return d.toISOString().split('.')[0].replace('T', ' ');
};

function formatDateYYYYMMDD(date: Date | string): string {
    const d: Date = date instanceof Date ? date : new Date(date);

    let month: string = '' + (d.getMonth() + 1)
    let day: string = '' + d.getDate()
    let year: number = d.getFullYear()

    // Make sure month and day are two digits
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

function formatHeaderDate(dateStr: string): number {
    if (typeof dateStr === 'string') {
        const dateParts = dateStr.split('-');
        return Number(dateParts[2]);
    }
    return null;
}

export {
    formatUSD, formatDateLong, formatDateTimeForQuery, formatDateYYYYMMDD, formatHeaderDate, formatDateString
}
